<template>
  <div id="CompanyPage">
    <v-container grid-list-md>
      <bread-crump-partial header="Über Uns"></bread-crump-partial>
      <v-layout row wrap>
        <v-flex xs12 sm8 md8>
          <div>
            <p>
              <strong>
                Die im Jahre 2013 gegründete Smolin BudgetPlan Gmbh ist ein Software- und Dienstleistungsunternehmen mit Sitz in Berlin.
                Wir sind spezialisiert auf Planungs- und Controllingsoftware, die Entwicklung moderner Anwendungen im Internet,
                auf dem Desktop und für mobile Endgeräte, sowie Big Data Cloud-Lösungen.
              </strong>
            </p>
            <p>
              Kundenorientierte Lösungen stehen bei uns an erster Stelle. So komplex IT-Dienstleistungen auch sind, wir gestalten sie nachvollziehbar
              und in enger Abstimmung mit unseren Kunden. In Deutsch statt in Fachchinesich, mit Wissentransfer statt geheimniskrämerei,
              denn ohne gegenseitiges Verstehen ist Zufriedenheit kaum zu erreichen.
            </p>
            <p>
              Damit Sie Ihre Ziele erreichen, übernehmen wir für Sie von der Beratung und Konzeption über die Entwicklung bis zur Betreuung
              der Anwendungen im Rechenzentrum oder in der Cloud alle Aufgaben. Ganz nach Ihrem Bedarf. Wir finden immer
              die optimalste Lösung für Sie und gewährleisten auch nachdem ein Projekt erfolgreich umgesetzt wurde, unseren
              zuverlässigen Service.
            </p>
            <accordion :panels="panelItems">Leistungen der Smolin BudgetPlan GmbH:</accordion>
          </div>
        </v-flex>
        <v-flex xs12 sm4 md4>
          <contact-widget></contact-widget>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import BreadCrumpPartial from './partials/BreadCrumpPartial'
import Accordion from './widgets/AccordionWidget'
import ContactWidget from './widgets/ContactWidget'

export default {
  name: 'CaompanyPage',
  components: {
    BreadCrumpPartial,
    Accordion,
    ContactWidget
  },
  data () {
    return {
      panelItems: [{
        icon: 'local_offer',
        color: 'blue',
        title: 'Individuelle Softwareentwicklung',
        text: 'Für viele Unternehmen ist eine maßgeschneiderte Softwareentwicklung die beste Option. Statt mehrerer suboptimaler Lösungen und ihrer unüberschaubaren Folgekosten schaffen Sie so exakt die Software an, die Sie und Ihre Mitarbeiter brauchen.'
      },
      {
        icon: 'local_offer',
        color: 'blue',
        title: 'Angepasste Standardsoftware',
        text: ' Bewährte Standardlösungen für Text- oder Tabellenbearbeitung werden zwar in vielen Betrieben eingesetzt, dennoch werden meist nur ca. 5% der verfügbaren Funktionen sinnvoll eingesetzt. Durch relativ kleine Anpassungen an Workflows und Vorlagen lässt sich die Produktivität in diesem Bereich nachhaltig steigern.'
      },
      {
        icon: 'local_offer',
        color: 'blue',
        title: 'Mobile Anwendungen &amp; Applikationen',
        text: 'Die Ausweitung der Funktionalitäten auf mobiler Geräte und Tablets stellen eine einschneidende Innovation in der Informationstechnologie dar. Mobilität bedeutet Zugriff auf Informationen zu jeder Zeit und von überall. Sie verschafft Kunden, Partnern und Lieferanten Flexibilität bei der Zusammenarbeit.'
      },
      {
        icon: 'local_offer',
        color: 'green',
        title: 'Beratung und Integration',
        text: 'Individuell, umfassend und kompotent unterstützen wir Sie bei der Konzeption, Umsetzung und Betreueung ihrer Projekte. Unsere IT-Beratung umfasst Strategieentwicklung, Anforderungsanalyse und Konzepterstellung.'
      },
      {
        icon: 'local_offer',
        color: 'yellow accent-4',
        title: 'Kundenservice',
        text: 'Für eine optimale Nutzung unser Lösungen bieten wir auch Schulungen an, die es den Anwendern ermöglichen alle Funktionen effizient einzusetzen. Neben den Schulungen sind auch Workshops zur Auffrischung der Kenntnisse Bestandteil unseres Leistungsangebotes.'
      }
      ]
    }
  }
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/CompanyPage.vue